export const getStoreInfo = () => {
  const storeInfo = localStorage.getItem('storeInfo');
  const info = JSON.parse(storeInfo);

  return info;
};
